module.exports = __webpack_public_path__ + "static/media/rr-3.b150e395.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/rr-3.png
// module id = 121
// module chunks = 0